import React from "react";
import PropTypes from "prop-types";
import { Card, Row, Col, Button, Form, Modal } from "antd";
import { LoaderSkeleton } from "components";
import { List, Map } from "immutable";
import "styles/form.css";
import shortID from "uuid/v4";
import cx from "classnames";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { BRANDS_TABLE_FORM } from "constants/form-fields";
import moment from "moment";
import { CompanyService } from "services";
import { STATE_STATUS } from "constants/index";
import AddProductForm from "forms/add-product-form";
const FormItem = Form.Item;


class TopBrandsTable extends React.Component {
    state= {
        values: [],
        statIds: this.props.channelProductStats.map((v,k) => k),
        removed_stats: [],
        productStats:
        this.props.channelProductStats && this.props.channelProductStats.size ? this.props.channelProductStats
            : new List([]),
        openAddProductModal: false
    };

    componentDidUpdate() {
        if(this.props.channelProductStats.size > this.state.statIds.size) {
            this.setState({
                statIds: this.props.channelProductStats.map((v,k) => k),
                removed_stats:[]
            });
        }
        if( this.props.channelProductStats &&
            this.props.channelProductStats.size &&
            this.state.statIds.size &&
            this.props.channelProductStats.size === this.state.statIds.size
            && this.props.channelProductStats.last().id !== this.state.statIds.last()
        ) {
            this.setState({
                statIds: this.props.channelProductStats.map((v,k) => k),
                removed_stats:[]
            });
        }
    }

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    toggleFormGrid = (action = "ADD", id) => {
        const { statIds } = this.state;
        let removed_stats = this.state.removed_stats;
        const newID = shortID();
        switch (action) {
        case "ADD":
            this.setState({
                statIds: statIds.set(newID, newID)
            });
            break;
        case "REMOVE": {
            removed_stats.push(id);
            this.setState({
                removed_stats: removed_stats
            });
            break;
        }
        default:
        }
    };

    saveStats = () => {
        const { form } = this.props;
        form.validateFields((err, values) => {
            let value_types = values["brands"];
            let newValues = new Map(values).filter((_, k) => k !== "brands").map((_, key) => {
                _.id = !isNaN(+key) ? key : null;
                _.channel_product = _.channel_product.id;
                _.value_type = new Map(value_types).find((__,k) => k.includes(key)).value_type;
                _.is_active = true;
                if(_.value_type === 1) {
                    _.amount = _.value;
                }
                if(_.value_type === 2) {
                    _.percentage = _.value;
                }
                return _;

            });
            if(this.props.channelProductStats && this.props.channelProductStats.size) {
                let deletedBrands = this.props.channelProductStats
                    .filter(_ => this.state.removed_stats.includes(_.id))
                    .map(_ => {
                        let row = _;
                        row.is_active = false;
                        row.from_period = moment(_.from_period);
                        row.to_period = moment(_.to_period);
                        row.channel_product = _.channel_product && _.channel_product.id;
                        return row;
                    });
                newValues = newValues.merge(deletedBrands);
            }
            this.props.updateBrands(newValues);
        });
    }

    addProducts = (values) => {
        this.setState({
            openAddProductModal: false
        }, () => {
            this.props.addNewChannelProduct(values);
        });
    }

    onSelectProducts = (id, val) => {
        this.props.form.setFieldsValue({
            [`${id}.name`]: val.name
        });
    }

    isLoading = () => {
        if(this.props.channelProductStatsStatus === STATE_STATUS.FETCHING || this.props.channelProductStatsStatus === STATE_STATUS.UPDATING) {
            return true;
        }
        return false;
    }

    onSearchProducts = (val) => {
        return CompanyService.getChannelProducts(val).then(({data}) => {
            return {
                data
            };
        });
    }

    render() {
        return (
            <React.Fragment>     
                <Modal
                    title={"Add New Product"}
                    visible={this.state.openAddProductModal}
                    footer={null}
                    onCancel={() => {
                        this.setState({
                            openAddProductModal: false
                        });
                    }}
                    closable={true}
                    destroyOnClose={true}
                >
                    <AddProductForm
                        onSubmit={this.addProducts}
                    />
                </Modal>   
                <LoaderSkeleton loading={this.isLoading()}>
                    <Row>
                        <Col span={24}>
                            <Card
                                title={"Company Details"}
                                extra={
                                    this.props.isUserAllowedToEdit ? 
                                        [
                                            <Button
                                                type={"link"}
                                                key={"new-product"}
                                                icon={"plus"}
                                                onClick={() => this.setState({
                                                    openAddProductModal: true
                                                })}    
                                                disabled={this.props.recreditViewOnlyPermission}
                                            >
                                                {"Add Company Details"}
                                            </Button>,
                                            <Button key={"save" }
                                                disabled={this.props.recreditViewOnlyPermission}
                                                onClick={this.saveStats} type="link">Save</Button>
                                        ]
                                        : null
                                }
                            >
                                <div className="mb-10">
                                    {
                                        this.state.statIds && 
                                            this.state.statIds.size ?
                                            this.state.statIds.toList().filter(_ => !this.state.removed_stats.length || !this.state.removed_stats.includes(_)).map(_ => (
                                                <div
                                                    key={`Brands-${_}`}
                                                    className="form-row form-row-compact bg-grey p-10 br-3">
                                                    {BRANDS_TABLE_FORM.map((field, fieldName) => {
                                                        if(fieldName === "channel_product") {
                                                            field.onSelect = this.onSelectProducts.bind(null, _);
                                                            field.onSearch = this.onSearchProducts;
                                                        }
                                                        if(fieldName === "value") {
                                                            field.addAfter.name = `brands.${_}|brand.${"value_type"}`;
                                                        }
                                                        if(!this.props.isUserAllowedToEdit) {
                                                            field.disabled=true;
                                                        }
                                                        return this.fieldGenerator(
                                                            `${_}.${fieldName}`,
                                                            field,
                                                            this.getErrorOnField(`${_}.${fieldName}`)
                                                        )();
                                                    }).toList()}
                                                    <FormItem className={cx("m-0 form-btn")}>
                                                        <Button
                                                            shape="circle"
                                                            icon={"minus"}
                                                            disabled={this.props.recreditViewOnlyPermission}
                                                            onClick={this.toggleFormGrid.bind(
                                                                null,
                                                                "REMOVE",
                                                                _
                                                            )}
                                                        />
                                                    </FormItem>
                                                </div>
                                            )) : null
                                    }
                                </div>
                                {this.props.isUserAllowedToEdit ? <FormItem className={cx("form-btn m-0")}>
                                    <Button
                                        type="dashed"
                                        icon={"plus"}
                                        disabled={this.props.recreditViewOnlyPermission}
                                        onClick={this.toggleFormGrid.bind(null, "ADD")}>
                                        Add Brand
                                    </Button>
                                </FormItem> : null}
                            </Card>
                        </Col>
                    </Row>
                </LoaderSkeleton>
            </React.Fragment>
        );
    }
}

TopBrandsTable.propTypes = {
    form: PropTypes.object,
    channelProductStats: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    caseId: PropTypes.number,
    products: PropTypes.array,
    updateBrands: PropTypes.func,
    channelProductStatsStatus: PropTypes.string,
    isUserAllowedToEdit: PropTypes.bool,
    addNewChannelProduct: PropTypes.func,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default Form.create({
    mapPropsToFields: ({channelProductStats}) => {
        let values = channelProductStats;
        if(values && values.size > 0) {
            return values
                .map((value) => {
                    return new Map(value).map((v, k)=> {
                        if(["to_period", "from_period"].includes(k)) {
                            return Form.createFormField({
                                value: moment(v)
                            });
                        }
                        return Form.createFormField({
                            value: v
                        });
                    }).toJS();
                }).toJS();
        }
    }
}) (TopBrandsTable);